/* eslint-disable @typescript-eslint/no-explicit-any */
// DataOps widget registry entries (simple definitions for the widget picker / registry).
// These are distinct from the rich DATAOPS_WIDGETS in dataopsWidgets.ts which include getData functions.

import {
  REGISTRY_WIDGET_CATEGORIES,
  REGISTRY_WIDGET_SIZES,
  REGISTRY_WIDGET_TYPES,
  REGISTRY_ICONS,
} from './widgetRegistryConstants';

const C = REGISTRY_WIDGET_CATEGORIES;
const S = REGISTRY_WIDGET_SIZES;
const T = REGISTRY_WIDGET_TYPES;

export const DATAOPS_REGISTRY_WIDGETS = [
  // DATAOPS WIDGETS
  {
    id: 'total-datasets',
    name: 'Total Datasets',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'All datasets tracked',
    icon: REGISTRY_ICONS.FiPackage,
    dataSource: 'dataops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'data-quality-score',
    name: 'Data Quality Score',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.MEDIUM,
    description: 'Overall data quality rating',
    icon: REGISTRY_ICONS.FiStar,
    dataSource: 'dataops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'successful-runs',
    name: 'Successful Runs',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Completed data job runs',
    icon: REGISTRY_ICONS.FiCheckCircle,
    dataSource: 'dataops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'failed-runs',
    name: 'Failed Runs',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Failed job executions',
    icon: REGISTRY_ICONS.FiXCircle,
    dataSource: 'dataops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'pipeline-runs-chart',
    name: 'Pipeline Runs',
    category: C.DATAOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Run status distribution over time',
    icon: REGISTRY_ICONS.FiTrendingUp,
    dataSource: 'dataops',
    refreshRate: 300000,
    supportsDateFilter: true
  },

  // DATAOPS WIDGETS (Additional)
  {
    id: 'schema-changes',
    name: 'Schema Changes',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Recent schema modifications',
    icon: REGISTRY_ICONS.FiRefreshCw,
    dataSource: 'dataops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'avg-run-duration',
    name: 'Avg Run Duration',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Average pipeline runtime',
    icon: REGISTRY_ICONS.FiClock,
    dataSource: 'dataops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'data-quality-trend',
    name: 'Quality Trend',
    category: C.DATAOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Quality score over time',
    icon: REGISTRY_ICONS.FiTrendingUp,
    dataSource: 'dataops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'freshness-alerts',
    name: 'Freshness Alerts',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Stale data warnings',
    icon: REGISTRY_ICONS.FiClock,
    dataSource: 'dataops',
    refreshRate: 60000,
    supportsDateFilter: false
  },
  {
    id: 'runs-by-status',
    name: 'Runs by Status',
    category: C.DATAOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Success/Failed/Running breakdown',
    icon: REGISTRY_ICONS.FiBarChart2,
    dataSource: 'dataops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'pipeline-success-rate',
    name: 'Pipeline Success',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Successful run percentage',
    icon: REGISTRY_ICONS.FiCheckCircle,
    dataSource: 'dataops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'data-volume',
    name: 'Data Volume',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Total data processed (TB)',
    icon: REGISTRY_ICONS.FiDatabase,
    dataSource: 'dataops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'dataset-ownership',
    name: 'Dataset Ownership',
    category: C.DATAOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Datasets by owner',
    icon: REGISTRY_ICONS.FiUser,
    dataSource: 'dataops',
    refreshRate: 600000,
    supportsDateFilter: false
  },
  {
    id: 'column-level-quality',
    name: 'Column Quality',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Column-level DQ score',
    icon: REGISTRY_ICONS.FiBarChart2,
    dataSource: 'dataops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'events-today',
    name: 'Events Today',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Pipeline events count',
    icon: REGISTRY_ICONS.FiActivity,
    dataSource: 'dataops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'total-jobs',
    name: 'Total Jobs',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'All data jobs monitored',
    icon: REGISTRY_ICONS.FiSettings,
    dataSource: 'dataops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'active-pipelines',
    name: 'Active Pipelines',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Currently running',
    icon: REGISTRY_ICONS.FiRefreshCw,
    dataSource: 'dataops',
    refreshRate: 60000,
    supportsDateFilter: false
  },
  {
    id: 'degraded-datasets',
    name: 'Degraded Datasets',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Quality or freshness issues',
    icon: REGISTRY_ICONS.FiAlertTriangle,
    dataSource: 'dataops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'datasets-by-type',
    name: 'Datasets by Type',
    category: C.DATAOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Dataset type distribution',
    icon: REGISTRY_ICONS.FiBarChart2,
    dataSource: 'dataops',
    refreshRate: 600000,
    supportsDateFilter: false
  },
  {
    id: 'completeness-percentage',
    name: 'Data Completeness',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Data completeness metric',
    icon: REGISTRY_ICONS.FiCheckCircle,
    dataSource: 'dataops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'accuracy-percentage',
    name: 'Data Accuracy',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Data accuracy score',
    icon: REGISTRY_ICONS.FiTarget,
    dataSource: 'dataops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'timeliness-percentage',
    name: 'Data Timeliness',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Data freshness metric',
    icon: REGISTRY_ICONS.FiClock,
    dataSource: 'dataops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'consistency-percentage',
    name: 'Data Consistency',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Consistency score',
    icon: REGISTRY_ICONS.FiRefreshCw,
    dataSource: 'dataops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'failed-quality-checks',
    name: 'Failed Quality Checks',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Recent quality failures',
    icon: REGISTRY_ICONS.FiXCircle,
    dataSource: 'dataops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'upstream-dependencies',
    name: 'Upstream Dependencies',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Number of data sources',
    icon: REGISTRY_ICONS.FiArrowUp,
    dataSource: 'dataops',
    refreshRate: 600000,
    supportsDateFilter: false
  },
  {
    id: 'downstream-dependencies',
    name: 'Downstream Dependencies',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Number of consumers',
    icon: REGISTRY_ICONS.FiArrowDown,
    dataSource: 'dataops',
    refreshRate: 600000,
    supportsDateFilter: false
  },
  {
    id: 'lineage-depth',
    name: 'Lineage Depth',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Transformation levels',
    icon: REGISTRY_ICONS.FiMaximize2,
    dataSource: 'dataops',
    refreshRate: 600000,
    supportsDateFilter: false
  },
  {
    id: 'running-jobs',
    name: 'Running Jobs',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Currently executing',
    icon: REGISTRY_ICONS.FiPlay,
    dataSource: 'dataops',
    refreshRate: 60000,
    supportsDateFilter: false
  },
  {
    id: 'datasets-with-owners',
    name: 'Datasets with Owners',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Assigned ownership',
    icon: REGISTRY_ICONS.FiUser,
    dataSource: 'dataops',
    refreshRate: 600000,
    supportsDateFilter: false
  },
  {
    id: 'active-tags',
    name: 'Active Tags',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Classification tags',
    icon: REGISTRY_ICONS.FiTag,
    dataSource: 'dataops',
    refreshRate: 600000,
    supportsDateFilter: false
  },
  {
    id: 'governance-rules',
    name: 'Governance Rules',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Active policies',
    icon: REGISTRY_ICONS.FiFileText,
    dataSource: 'dataops',
    refreshRate: 600000,
    supportsDateFilter: false
  },
  {
    id: 'data-stewards',
    name: 'Data Stewards',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Steward count',
    icon: REGISTRY_ICONS.FiUsers,
    dataSource: 'dataops',
    refreshRate: 600000,
    supportsDateFilter: false
  },
  {
    id: 'pii-datasets',
    name: 'PII Datasets',
    category: C.DATAOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Sensitive data tracking',
    icon: REGISTRY_ICONS.FiLock,
    dataSource: 'dataops',
    refreshRate: 600000,
    supportsDateFilter: false
  },
  {
    id: 'events-by-type',
    name: 'Events by Type',
    category: C.DATAOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Event type distribution',
    icon: REGISTRY_ICONS.FiBarChart2,
    dataSource: 'dataops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
];
